import {Directive, EventEmitter, HostListener, Input, Output} from "@angular/core";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {UndoReasonComponent} from "./undo-reason.component";

@Directive({
  selector: '[appUndoReason]'
})
export class UndoReasonDirective {

  @Input({required: true})
  public inputType: string;
  @Input({required: true})
  public inputTitle: string;
  @Output()
  private reason: EventEmitter<any> = new EventEmitter<any>();

  constructor(private modalService: NgbModal) {
  }

  @HostListener('click')
  public onClick(): void {
    const options = {backdropClass: 'app-confirm-modal'} as NgbModalOptions;
    let popup = this.modalService.open(UndoReasonComponent, options);
    popup.componentInstance.inputType = this.inputType;
    popup.componentInstance.inputTitle = this.inputTitle;
    popup.result.then(
      (data) => this.reason.emit(data),
      () => popup.close()
    );
  }
}
